import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../locale";
import { formatStatus } from "./orderDetailsUtils";

const OrderDetailsSellerPickupPanel = ({
  isPhysicalProduct,
  parcelInfo,
  loadingLabel,
  downloadLabel,
}) => {
  if (!isPhysicalProduct || !parcelInfo) return null;

  return (
    <div className="mb-4">
      <div className="flex align-items-center justify-content-center mt-4">
        <i className="pi pi-exclamation-triangle text-3xl mr-2" />
        <h3 className="m-0">{localeText("attention")}</h3>
      </div>
      <p className="text-center">
        {localeText("dowloadYourLabelAndPutInYourProduct")}
      </p>
      <div className="flex justify-content-center">
        <Button
          className="mx-auto mt-1"
          label={localeText("downloadLabel")}
          loading={loadingLabel}
          onClick={downloadLabel}
        />
      </div>

      <h4>{localeText("pickupInfo")}</h4>
      <hr />

      <div className="grid">
        <div className="lg:col-6 col-12">
          <label>
            <b>{localeText("status")}:</b>
          </label>
          <p>
            {parcelInfo?.tracking_state
              ? localeText(formatStatus(parcelInfo.tracking_state))
              : localeText("youDontHave")}
          </p>
        </div>
        <div className="lg:col-6 col-12">
          <label>
            <b>{localeText("shippingMethod")}:</b>
          </label>
          <p>{parcelInfo?.courier || localeText("youDontHave")}</p>
        </div>
        <div className="lg:col-6 col-12">
          <label>
            <b>{localeText("trackingNumber")}:</b>
          </label>
          <p>{parcelInfo?.shipping_code || localeText("youDontHave")}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsSellerPickupPanel;

